<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CInput
          label="Street Address"
          placeholder=""
          v-model="form.street_address"
          :horizontal="true"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          label="City"
          placeholder=""
          v-model="form.city"
          :horizontal="true"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          label="Province/State"
          placeholder=""
          v-model="form.region"
          :horizontal="true"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          label="Country"
          placeholder=""
          v-model="form.country"
          :horizontal="true"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          label="Postal/Zip"
          placeholder=""
          v-model="form.postal"
          :horizontal="true"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="7"></CCol>
      <CCol sm="5">
        <CButtonGroup class="w-100">
          <CButton @click="$emit('cancel')" color="default" class="btn-square">Cancel</CButton>
          <CButton class="btn-sf btn-square" @click="save">Save</CButton>
        </CButtonGroup>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Location from "../../../models/Location"
import CustomerLocation from "../../../models/CustomerLocation"

export default {
  name: 'LocationForm',
  data() {
    return {
      form: {
        street_address: null,
        city: null,
        region: null,
        country: null,
        postal: null
      }
    };
  },
  methods: {
    save() {
      this.createLocation().then((location) => {
        this.createCustomerLocation(location).then((customer_location) => {
          this.$emit('onSave', customer_location, location);
          CustomerLocation.api().export(customer_location.id);
        });
      });
    },
    createLocation: function() {
      let payload = JSON.parse(JSON.stringify(this.form));
      let temp = Object.values(JSON.parse(JSON.stringify(payload)));
      payload.address = temp.filter(x => x).join(', ');
      return Location.api().create(payload).then((response) => {
        return response.entities.locations[0];
      });
    },
    createCustomerLocation: function(location) {
      return CustomerLocation.api().create({
        customer_id: localStorage.getItem('customer_id'),
        location_id: location.id
      }).then((response) => {
        return response.entities.customer_locations[0];
      });
    }
  }
}
</script>
